import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "../tokens.service";

export const getProductoList = async () => {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

  const serverResponse = await mainAxios.get(
    "/v1/producto/list",
    config
  );
  return serverResponse.data

};

export async function getProductosByAlianza(alianzaId) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const body = {
    alianza_intermx_id: alianzaId
  };

  const response = await mainAxios.post("/v1/producto/list/filtros", body, config);
  return response.data;
}

export async function getProductosByFiltros(body) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const response = await mainAxios.post("/v1/productos/filtros", body, config);
  return response.data;
}

export async function getProductoByID(id) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const response = await mainAxios.get("/v1/producto/id/"+id, config);
  return response.data;
}

export async function getProductoDetalleByID(id) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const response = await mainAxios.get(`/v1/producto/detalle/${id}`, config);
  return response.data;
}

export async function getAllProductsWithAlianza() {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const response = await mainAxios.get("/v1/alianzas/productos", config);
  return response.data;
}

export async function createProductAlianza(payload) {
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    }
  };

  const response = await mainAxios.post("/v1/producto/alianza/crear", payload, config);
  return response.data;
}

export async function insertProduct(body) {
  const config = {
    headers: {
      Authorization: "Bearer " + localStorage.agenteAccessToken,
    }
  };

  const response = await mainAxios.post("/v1/producto", body, config);
  return response.data;
}